import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatLegacyCheckboxModule as MatCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';

import { MgFormFieldModule } from '@app/src/app/form-field';

import { CalendarScheduleOptionsComponent } from './CalendarScheduleOptions.component';

@NgModule({
  imports: [
    // Minga dependencies
    MgFormFieldModule,

    // External dependencies
    CommonModule,
    FormsModule,
    MatFormFieldModule,
    MatCheckboxModule,
    MatSelectModule,

    MatButtonToggleModule,
  ],
  declarations: [CalendarScheduleOptionsComponent],
  exports: [CalendarScheduleOptionsComponent],
})
export class CalendarScheduleOptionsModule {}
